module.exports = __webpack_public_path__ + "img/home-stagione-2023.99458d83.png";